/**
*@title 엑스포 메인 페이지
*@date 2022-02-07
*@author 홍수희, 박지훈, 권윤성
*@desc
*@etc(change)
*/

import React from 'react';

import '../css/main.css?ver=1';
import '../css/reset.css?ver=1';
import '../css/top-menu.css?ver=1';

import MainLogo from './overview/MainLogo';
import ExpoOverview from "./overview/ExpoOverview";
import ExpoProgram from "./overview/ExpoProgram";
import ExpoIndustrial from "./overview/ExpoIndustrial";
import QuickButton from './overview/QuickButton';
import Organize from './overview/Organize';
import MainTimeTable from "./overview/MainTimeTable";
import ConversationNobel from './visitor/ConversationNobel';
import ConversationRegiButton from './overview/ConversationRegiButton';
import Footer from './Footer';

import video from "../assets/GenomeBioExpo_2022_video.mp4";


class Main extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            scrollY: 0,
        }
        this.scrollHandler = this.scrollHandler.bind(this);
    }


    componentDidMount() {
        window.addEventListener('scroll',this.scrollHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll',this.scrollHandler);
    }

    scrollHandler = () => {
        this.setState({scrollY:window.pageYOffset})
        // console.log(this.state.scrollY);
    }

    render() {
        
        return(
            <div className='fullPage-container'>
                <section className='one' id = "first">
                    <MainLogo/>
                </section>
                {/*<QuickButton/>*/}
                <section className='main-video'>
                    <video autoPlay muted id="background-video" >
                        <source src={video} type="video/mp4" />
                    </video>
                </section>
                <section className='two' id='two'>
                    <ExpoOverview/>
                </section>
                <section className='three'>
                    <ExpoProgram />
                </section>

                {/*<section>
                    <ExpoIndustrial />
        </section>*/}
                {/*<section className='two'>
                    <MainTimeTable />
    </section>*/}
                {/*<section className='two'>
                    <ConversationNobel/>
                    <ConversationRegiButton/>
                </section>*/}
                {/*<section className='two'>
                    <Organize/>
            </section>*/}
                <section className='section-footer'>
                    <Footer/>
                </section>
            </div>
        )
    }
}

export default Main;